import { useState, useEffect } from 'react';

/**
 * 字體切換 Hook
 * 支援兩種字體：BpmfGenSenRounded（預設）和第二字體（可配置）
 */
export function useFontToggle() {
  const FONT_KEY = 'preferred-font';

  // 字體選項
  const FONTS = {
    primary: {
      name: 'BpmfGenSenRounded',
      label: '圓體',
      class: 'font-round',
    },
    secondary: {
      name: 'Noto Serif TC',
      label: '明體',
      class: 'font-serif',
    },
  };

  // 暫時強制使用明體，忽略 localStorage（之後要開放切換再移除這行）
  // 暫時移除 /public/BpmfGenSenRounded/ 資料夾和字體
  const [currentFont, setCurrentFont] = useState('secondary');

  // 從 localStorage 讀取或使用預設字體（暫時停用）
  // const [currentFont, setCurrentFont] = useState(() => {
  //   if (typeof window !== 'undefined') {
  //     const saved = localStorage.getItem(FONT_KEY);
  //     return saved || 'secondary';
  //   }
  //   return 'secondary';
  // });

  // 切換字體
  const toggleFont = () => {
    const newFont = currentFont === 'primary' ? 'secondary' : 'primary';
    setCurrentFont(newFont);
    localStorage.setItem(FONT_KEY, newFont);
  };

  // 設定特定字體（用於 dropdown）
  const setFont = (fontKey) => {
    if (FONTS[fontKey]) {
      setCurrentFont(fontKey);
      localStorage.setItem(FONT_KEY, fontKey);
    }
  };

  // 應用字體到 body
  useEffect(() => {
    const font = FONTS[currentFont];
    if (font && typeof document !== 'undefined') {
      // 移除其他字體 class
      document.body.classList.remove('font-round', 'font-serif');
      // 添加當前字體 class - CSS 會處理所有子元素的字體繼承
      document.body.classList.add(font.class);
    }
  }, [currentFont]);

  return {
    currentFont,
    currentFontInfo: FONTS[currentFont],
    toggleFont,
    setFont,
    fonts: FONTS,
  };
}
